import React from 'react';
import { TARGET_KM } from '../constants';

const createConfetti = () => {
  const confetti = [];
  for (let i = 0; i < 50; i++) {
    confetti.push({
      id: i,
      left: `${Math.random() * 100}%`,
      delay: Math.random() * 3,
      color: ['#f39c12', '#e74c3c', '#3498db', '#2ecc71'][Math.floor(Math.random() * 4)]
    });
  }
  return confetti;
};

const CelebrationOverlay = ({ onClose }) => (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    }}
    onClick={onClose}
  >
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          color: 'white',
          fontSize: '2.5rem',
          textAlign: 'center',
          zIndex: 2,
        }}
      >
        🍺 {TARGET_KM} Kilometer erreicht! 🍺
      </div>
      {createConfetti().map(confetti => (
        <div
          key={confetti.id}
          style={{
            position: 'absolute',
            width: '15px',
            height: '15px',
            left: confetti.left,
            backgroundColor: confetti.color,
            animation: `confetti-fall 3s linear infinite`,
            animationDelay: `${confetti.delay}s`,
          }}
        />
      ))}
    </div>
  </div>
);

export default CelebrationOverlay;
